export const SPAREPART_SATUAN = ['pcs', 'set', 'L']

export const ROLE_PATHS = {
  1: /.*/,
  2: /.*/,
  3: /^\/(rent|stock\/alat-berat\/\d+\/rent\/\d+\/\d+)/,
  4: /^\/(rent|stock\/alat-berat\/\d+\/rent\/\d+\/\d+)/,
}

export const PROGRESS_STEP = 0.1
